import React, { useEffect, useState } from 'react';
import '../../../index.scss';

// material
// ICON

import DeleteIcon from '@material-ui/icons/Delete';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

// other
import { useDispatch, useSelector } from 'react-redux';
import { GridCellParams, GridRowModel } from '@material-ui/data-grid';
import { Iobject } from 'main_type';
// component
import {
  blobDownload,
  getDeleteExcelFile,
  getDownloadExcelFile,
  getDownloadExcelFileNew,
  getExcelFileList,
  snackBarRsp,
} from 'main_api';
import { getColWidthByField } from 'main_func';
import { IconButton, Tooltip } from '@material-ui/core';
import { IColDef } from 'components/Material/Table/type';
import { useSnackbar } from 'notistack';
import { setLoadingRedux } from 'reducers/shareData/action';
import { PopConfirm2 } from 'components/Material/PopDialog/PopDialog';
import { IPopConfirm2 } from 'components/Material/PopDialog/IPopDialog';
import Header from 'components/Header';
import Menu from '../../../components/Menu';
import { getUserInfoRedux } from '../../../reducers/shareData/selector';
import Table from '../../../components/Material/Table/index';

/** 下載報表檔案 */
const RptDownload = (): JSX.Element => {
  const dispatch = useDispatch();
  const { user } = useSelector(getUserInfoRedux);
  const { enqueueSnackbar } = useSnackbar();

  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [rowData, setRowData] = useState<unknown[]>([]);
  const [colList, setColList] = useState<IColDef[]>([]);
  const [randomValue] = useState(Math.random());
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<GridRowModel>(
    {} as GridRowModel
  );

  interface IExcelFileList {
    downloadTime: string;
    updTime: string;
    isDownload: string;
    status: string;
    fileName: string;
  }
  const init = async () => {
    // 取得下載清單
    const result = await getExcelFileList();
    if (result.data && result.data.status === 0 && result.data.data) {
      setColList(
        getColWidthByField([
          { headerName: '功能', field: 'action', customCell: true },
          { headerName: '項次', field: 'itemNo' },
          {
            headerName: '檔案名',
            field: 'fileName',
            flex: 1,
            align: 'left',
            headerAlign: 'left',
          },
          { headerName: '檔案狀態', field: 'status' },
          { headerName: '建立時間', field: 'updTime' },
          { headerName: '已下載', field: 'isDownload' },
          { headerName: '下載時間', field: 'downloadTime' },
        ])
      );

      setRowData(
        (result.data.data as IExcelFileList[]).map((v) => {
          const { downloadTime, updTime, isDownload, status, fileName } = v;
          return { downloadTime, updTime, isDownload, status, fileName };
        })
      );
      setOpenSearchTable(true);
    } else if (String(result.data.msg).length > 0) {
      enqueueSnackbar(result.data.msg);
    }
  };

  // const handleBreadClick = (
  //   event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  // ) => {
  //   event.preventDefault();
  // };

  const handleDownload = async (selectedRow: GridRowModel) => {
    // dispatch(setLoadingRedux(true));
    getDownloadExcelFileNew(selectedRow.fileName);
    // dispatch(setLoadingRedux(false));
    init();
  };

  const handleDelete = async (selectedRow: GridRowModel) => {
    dispatch(setLoadingRedux(true));
    const result = await getDeleteExcelFile(selectedRow.fileName);
    if (result && result.data.status === 0) {
      snackBarRsp(enqueueSnackbar, result);
    }
    dispatch(setLoadingRedux(false));
    setOpenConfirm(false);
    init();
  };

  // 設定confirm
  const confirmProps: IPopConfirm2 = {
    show: openConfirm,
    title: '系統訊息',
    msg: '請確認是否進行刪除？',
    handleConfirm: () => handleDelete(selectedData),
    handleExit: () => setOpenConfirm(false),
  };

  const renderCell = (params: GridCellParams) => {
    const { field, row } = params;
    switch (field) {
      case 'action':
        return (
          <>
            <Tooltip title="下載">
              <IconButton
                color="primary"
                disabled={row.status !== '可下載'}
                onClick={() => handleDownload(row)}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="刪除">
              <IconButton
                color="secondary"
                disabled={row.status === '製表中'}
                onClick={() => {
                  // 打開confirm
                  setOpenConfirm(true);
                  // 給予row資料
                  setSelectedData(row);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={handleBreadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={handleBreadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">下載報表檔案</Typography>
        </Breadcrumbs> */}
      </div>
      <div style={{ color: 'red', fontSize: '2em' }}>
        <div>1. 若報表製作中，請待10分鐘後再更新畫面</div>
        <div>2. 檔案僅保留一個月</div>
      </div>
      {openSearchTable && (
        <Table
          // hideFooter
          key={randomValue}
          data={rowData as unknown as Iobject[]}
          columns={colList}
          rowsPerPageOptions={[100, 50, 10]}
          rootProps={{ style: { height: '400px' } }}
          pageSize={100}
          renderCell={renderCell}
        />
      )}
      {openConfirm && <PopConfirm2 {...confirmProps} />}
    </div>
  );
};

export default RptDownload;
